import { Component, HostListener, AfterViewInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { initSnow } from '../../utils/snow.util';

@Component({
    selector: 'app-public-navbar',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './public-navbar.component.html',
    styleUrls: ['./public-navbar.component.css']
})
export class PublicNavbarComponent implements AfterViewInit {
    mobileMenuOpen: boolean = false;
    showAllLanguages: boolean = false;

    constructor(private translate: TranslateService) {}

    changeLanguage(lang: string): void {
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
        localStorage.setItem('language', lang);
    }

    toggleMobileMenu(): void {
        this.mobileMenuOpen = !this.mobileMenuOpen;
        if (this.mobileMenuOpen) {
            document.body.style.overflow = 'hidden'; // Blocca lo scroll della pagina quando il menu è aperto
            document.body.style.position = 'fixed'; // Fissa il body
            document.body.style.width = '100%'; // Mantieni la larghezza
            document.body.style.touchAction = 'none'; // Previene i gesti touch
        } else {
            document.body.style.overflow = ''; // Ripristina lo scroll quando il menu è chiuso
            document.body.style.position = ''; // Ripristina la posizione
            document.body.style.width = ''; // Ripristina la larghezza
            document.body.style.touchAction = ''; // Ripristina i gesti touch
        }
    }

    closeMobileMenu(): void {
        this.mobileMenuOpen = false;
        document.body.style.overflow = ''; // Ripristina lo scroll
        document.body.style.position = ''; // Ripristina la posizione
        document.body.style.width = ''; // Ripristina la larghezza
        document.body.style.touchAction = ''; // Ripristina i gesti touch
    }

    // Chiudi il menu quando la finestra viene ridimensionata a dimensioni desktop
    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        if (window.innerWidth > 768 && this.mobileMenuOpen) {
            this.closeMobileMenu();
        }
    }

    ngAfterViewInit(): void {
      //initSnow('.snow-canvas', '.logo-img');
    }

    

}
